// extracted by mini-css-extract-plugin
export var dropdown = "_tv-0";
export var imageWrapper = "_tv-3";
export var itemNameContainer = "_tv-1";
export var productImage = "_tv-2";
export var spinnerWrapper = "_tv-4";